import { RegistrationCodeFormValue } from '../../models/appliance-details-stepped/registration-code-form-value.type';

export const mockRegistrationCodeFormValue: RegistrationCodeFormValue = {
  registrationCode: '782A31DTJ',
};
